import { ReactNode } from 'react'
import { Label } from '../../../ui/label'
import TooltipLabel from './TooltipLabel'

import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '../../../ui/select'

export type SelectOption<K = string> = { key: K; name: string }

type Props<K, V> = {
  title?: string
  id?: K
  value: V | undefined
  onChange: (value: V, id?: K) => void
  className?: string
  placeholder?: string
  tooltip?: ReactNode
  options?: any[]
  disabled?: boolean
}

export function SelectWithLabel<K = string, V = string>({
  placeholder = 'please choose an option from the list',
  ...props
}: Props<K, V>) {
  const onChange = (option: SelectOption<V>) => {
    props.onChange(option.key, props.id)
  }

  return (
    <div className="flex flex-col items-start w-full gap-1 group">
      {props.title !== undefined && (
        <div className="mb-1">
          {props.tooltip === undefined ? (
            <Label htmlFor={props.title}>{props.title}</Label>
          ) : (
            <TooltipLabel label={props.title} tooltip={props.tooltip} />
          )}
        </div>
      )}

      <Select
        defaultValue={props.value as string}
        onValueChange={(e) => props.onChange(e as V, e as K)}
        disabled={props.disabled !== undefined ? props.disabled : false}
      >
        <SelectTrigger>
          <SelectValue placeholder="please choose an option from the list" />
        </SelectTrigger>
        <SelectContent className={props.className}>
          {props.options?.map((option) => (
            <SelectItem
              onChange={() => onChange}
              key={option.key}
              value={option.key}
            >
              {option.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export default SelectWithLabel
